module.exports = __webpack_public_path__ + "media/images/icons/flags/GT-ed416e3e704fd0eb24386ceb56da5fec.svg";